import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaymentErrorScreenComponent } from '@app/modules/setting/dialogs/payment-error-screen/payment-error-screen.component';
import { AskSecurityKeyPasswordComponent } from '@app/modules/vault/components/dialogs/ask-security-key-password/ask-security-key-password.component';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { environment } from '@env/environment';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { CryptoService } from '../crypto/crypto.services';
import { FileListUpdate } from '../file-list-update/fileListUpdate.service';
import * as fileSaver from 'file-saver';
import { Store } from '@ngrx/store';
import { vaultStoreActions } from '@app/root-store';
import { Router } from '@angular/router';
import { ColoborationManagementAdmin } from '../coloboration-management-admin/coloboration-management-admin.service';
import { MovedToSharedVault } from '../moved-to-shared-vault/moved-to-shared-vault.service';
@Injectable({
  providedIn: 'root',
})
export class DataExtractionService {
  constructor(private readonly httpService: AmplifyHttpClient) {}
  dataExtractionForm(id) {
    const request = {
      vault_user_form_id: id,
    };
    const url = `api/data-extraction/data-extraction-form`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  addDataExtraction(data) {
    const url = `api/data-extraction/multi-form-extraction`;
    return this.httpService.post(url, data).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  dataExtractionManualTrigger(data) {
    const url = `api/data-extraction/manual-trigger`;
    return this.httpService.post(url, data).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  dataExtractionTableList(data) {
    const url = `api/data-extraction/data-extraction-by-folder-id`;
    return this.httpService.post(url, data).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getDataExtractionFormStatus(id) {
    const url = `api/data-extraction/data-extraction-by-form-id/${id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
}
